export default "__VITE_ASSET__76294fe0__"